import {
    libraryInitialize as neoCommonInitialize,
} from 'neo-common';

neoCommonInitialize();

import * as ClientHost from './ClientHost/index';
import * as GameEngine from './GameEngine/index';
import * as Communication from './Communication/index';
import * as RealityCheck from './RealityCheck/index';
import * as Platforms from './Platforms/index';
import * as Plugins from './Plugins/index';

export {
    ClientHost,
    GameEngine,
    Communication,
    RealityCheck,
    Platforms,
    Plugins
}


/** WEBPACK FOOTER **
 ** ./Engine/index.prod.ts
 **/